export const CHECK_VOUCHER_REQUEST = "CHECK_VOUCHER_REQUEST";
export const CHECK_VOUCHER_SUCCESS = "CHECK_VOUCHER_SUCCESS";
export const CHECK_VOUCHER_FAILURE = "CHECK_VOUCHER_FAILURE";
export const SET_VOUCHER_LOADING = "SET_VOUCHER_LOADING";
export const CLEAR_VOUCHER_LOADING = "CLEAR_VOUCHER_LOADING";
